// removed by extract-text-webpack-plugin
module.exports = {"noPadLeft":"FilterBox__noPadLeft___2YXJa","noPadHorizontal":"FilterBox__noPadHorizontal___1EjdD"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/users/components/FilterBox.scss
// module id = 1663
// module chunks = 0